import { apiClient } from "./client";
import type { EventVoteInfo, VoteHistory, VoteRequest } from "../types/swagger";
import {
  addMockVote,
  getMockEventVoteInfo,
  getMockVoteHistories,
} from "../mocks/fixtures/predictions";

const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

export const predictionsApi = {
  /**
   * イベント投票情報取得
   * GET /v1/event/{event_id}/vote
   */
  getEventVoteInfo: async (eventId: string): Promise<EventVoteInfo> => {
    if (USE_MOCK) {
      return getMockEventVoteInfo(eventId);
    }
    const { data } = await apiClient.get<EventVoteInfo>(
      `/event/${eventId}/vote`,
    );
    return data;
  },

  /**
   * 投票登録
   * POST /v1/event/{event_id}/vote
   */
  createEventVote: async (
    eventId: string,
    body: VoteRequest,
  ): Promise<void> => {
    if (USE_MOCK) {
      addMockVote(eventId, body.voted_user_id);
      return;
    }
    await apiClient.post(`/event/${eventId}/vote`, body);
  },

  /**
   * 投票履歴取得
   * GET /v1/vote/histories
   */
  getVoteHistories: async (): Promise<VoteHistory[]> => {
    if (USE_MOCK) {
      return getMockVoteHistories();
    }
    const { data } = await apiClient.get<VoteHistory[]>("/vote/histories");
    return data;
  },
};

